import { useCallback, useRef, useState } from "react";

const STORAGE_KEY = "rq_read_leads";

function loadReadSet() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Only keep entries from the last 30 days
      const cutoff = Date.now() - 30 * 24 * 60 * 60 * 1000;
      const valid = Object.entries(parsed).filter(([, ts]) => ts > cutoff);
      return new Map(valid);
    }
  } catch {}
  return new Map();
}

function saveReadMap(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(map)));
  } catch {}
}

export function useReadMessages() {
  const readMap = useRef(loadReadSet());
  const seenMediaSet = useRef(new Set());
  const [, forceUpdate] = useState(0);

  const markAsRead = useCallback((leadId) => {
    if (leadId && !readMap.current.has(leadId)) {
      readMap.current.set(leadId, Date.now());
      saveReadMap(readMap.current);
      forceUpdate((n) => n + 1);
    }
  }, []);

  const isRead = useCallback((leadId) => readMap.current.has(leadId), []);

  const markMediaSeen = useCallback((leadId) => {
    if (leadId && !seenMediaSet.current.has(leadId)) {
      seenMediaSet.current.add(leadId);
      forceUpdate((n) => n + 1);
    }
  }, []);

  const isMediaSeen = useCallback(
    (leadId) => seenMediaSet.current.has(leadId),
    []
  );

  return { markAsRead, isRead, readLeadIds: readMap.current, markMediaSeen, isMediaSeen };
}
